(function () {
    'use strict';

    angular.module('app')
        .factory('ManagerLogin', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "manager-login";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();
